import type { CapabilitySuggestion } from '@indutrust/capability-model';
import { createCrudEvents } from '@indutrust/shared-util';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/** CRUD events for the admin capability-suggestion store. */
export const adminCapabilitySuggestionCrudEvents =
  createCrudEvents<CapabilitySuggestion>('admin-capability-suggestion');

/**
 * Workflow events for admin review of capability-leaf suggestions —
 * approve / reject.
 *
 * @example
 * const dispatch = injectDispatch(adminCapabilitySuggestionWorkflowEvents);
 * dispatch.approveRequested({ id: 7 });
 */
export const adminCapabilitySuggestionWorkflowEvents = eventGroup({
  source: 'admin-capability-suggestion.workflow',
  events: {
    approveRequested: type<{ id: number }>(),
    rejectRequested: type<{ id: number; reason: string }>(),
    workflowSucceeded: type<{ suggestion: CapabilitySuggestion }>(),
    workflowFailed: type<{ error: string }>(),
  },
});
